import moment from 'moment-timezone';

/** Common abbreviations shown alongside GMT offset for quick recognition. */
const TZ_ABBREV: Record<string, string> = {
  UTC: 'UTC',
  'Europe/London': 'GMT/BST',
  'Europe/Paris': 'CET/CEST',
  'Europe/Berlin': 'CET/CEST',
  'Europe/Amsterdam': 'CET/CEST',
  'Europe/Brussels': 'CET/CEST',
  'Europe/Rome': 'CET/CEST',
  'Europe/Madrid': 'CET/CEST',
  'Europe/Warsaw': 'CET/CEST',
  'Europe/Prague': 'CET/CEST',
  'Europe/Budapest': 'CET/CEST',
  'Europe/Athens': 'EET/EEST',
  'Europe/Istanbul': 'TRT',
  'Europe/Sarajevo': 'CET/CEST',
  'Europe/Belgrade': 'CET/CEST',
  'Europe/Zagreb': 'CET/CEST',
  'America/New_York': 'EST/EDT',
  'America/Chicago': 'CST/CDT',
  'America/Denver': 'MST/MDT',
  'America/Los_Angeles': 'PST/PDT',
  'Asia/Dubai': 'GST',
  'Asia/Kolkata': 'IST',
  'Asia/Singapore': 'SGT',
  'Australia/Sydney': 'AEST/AEDT',
};

/** Human-readable timezone label with GMT offset and common abbrev, e.g. "GMT-5 (EST/EDT) — New York" */
export function formatTimezoneLabel(tz: string): string {
  try {
    const offset = moment.tz(tz).format('Z');
    const gmt = `GMT${offset}`;
    const abbrev = TZ_ABBREV[tz];
    if (tz === 'UTC') return 'GMT+0 (UTC)';
    const city = tz.includes('/') ? tz.split('/').pop()?.replace(/_/g, ' ') : tz;
    const suffix = city ?? tz;
    return abbrev ? `${gmt} (${abbrev}) — ${suffix}` : `${gmt} — ${suffix}`;
  } catch {
    return tz.replace(/_/g, ' ');
  }
}

export const CAMPAIGN_COMMON_TIMEZONES = [
  'UTC',
  'Europe/London',
  'Europe/Paris',
  'Europe/Berlin',
  'Europe/Amsterdam',
  'Europe/Brussels',
  'Europe/Rome',
  'Europe/Madrid',
  'Europe/Warsaw',
  'Europe/Prague',
  'Europe/Budapest',
  'Europe/Athens',
  'Europe/Istanbul',
  'Europe/Sarajevo',
  'Europe/Belgrade',
  'Europe/Zagreb',
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'Asia/Dubai',
  'Asia/Kolkata',
  'Asia/Singapore',
  'Australia/Sydney',
];
